import { render, staticRenderFns } from "./PavPatternRegionSelector.vue?vue&type=template&id=5a2054aa&scoped=true&"
import script from "./PavPatternRegionSelector.vue?vue&type=script&lang=js&"
export * from "./PavPatternRegionSelector.vue?vue&type=script&lang=js&"
import style0 from "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./PavPatternRegionSelector.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PavPatternRegionSelector.vue?vue&type=style&index=2&id=5a2054aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2054aa",
  null
  
)

export default component.exports